
import { LoginForm } from '../../../features/auth/LoginForm';
const imgWejhaLogoNew = "/logo.png";
import { motion } from 'framer-motion';

export const LoginCard = () => {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center px-6 md:px-12 lg:px-20 bg-white lg:bg-transparent">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="w-full max-w-[480px]"
      >
        {/* Modern Minimal Card with Glassmorphism for Desktop */}
        <div className="relative lg:bg-white/80 lg:backdrop-blur-2xl lg:border lg:border-white/50 lg:shadow-xl rounded-3xl overflow-hidden p-8 md:p-12">
          
          {/* Logo */}
          <div className="flex justify-start mb-8 text-[#2C9944]">
            <img src={imgWejhaLogoNew} alt="Wejha Smart Signage" className="h-[28px] object-contain" />
          </div>

          <div className="space-y-6">
            {/* Header Text */}
            <div className="space-y-1.5">
              <h1 className="text-2xl font-bold text-[#1D2739] tracking-tight">
                Welcome Back, Creator 👋
              </h1>
              <p className="text-[#667185] text-base font-medium">
                Continue building amazing content
              </p>
            </div>

            {/* Form Section */}
            <div className="w-full">
              <LoginForm />
            </div>


          </div>
        </div>

        {/* Brand App Links (Optional but makes it feel like Canva/SaaS) */}
        <div className="mt-8 flex justify-center gap-4 opacity-50 grayscale hover:grayscale-0 transition-all duration-500">
           {/* Add static images or icons for app stores if needed */}
        </div>
      </motion.div>
    </div>
  );
};
